/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

// pcg-viewer canvas: shared drawing primitives
// (core-viewer.js 1853-1857 setupCanvas, 1629-1646 drawCautionWindow,
// 178-197 drawPlayhead). Bodies verbatim; element lookup by id becomes an
// element argument, and drawPlayhead's reads of the playback/view globals come
// from the render context.

import { tToX } from "./view"

// core-viewer.js 1853-1857 — id lookup replaced by the element itself. The
// canvas takes its parent's width as an explicit size (upstream v0.8.3.18),
// so a narrowing workspace can shrink it rather than scroll it.
export function sizeCanvas(c, h) {
  const ctx = c.getContext("2d")
  const dpr = (typeof window !== "undefined" && window.devicePixelRatio) || 1
  const parentWidth = c.parentElement ? c.parentElement.clientWidth : c.getBoundingClientRect().width
  const W = Math.max(1, Math.floor(parentWidth))
  c.style.width = `${W}px`
  c.style.height = `${h}px`
  c.width = Math.round(W * dpr)
  c.height = Math.round(h * dpr)
  ctx.scale(dpr, dpr)
  return { c, ctx, W, H: h }
}

// core-viewer.js 1629-1646 — verbatim.
export function drawCautionWindow(ctx, x1, x2, y, h) {
  const w = Math.max(1, x2 - x1)
  ctx.fillStyle = "rgba(244,63,94,0.075)"
  ctx.fillRect(x1, y, w, h)
  ctx.strokeStyle = "rgba(244,63,94,0.24)"
  ctx.lineWidth = 1
  ctx.setLineDash([2, 4])
  ctx.strokeRect(x1 + 0.5, y + 0.5, Math.max(1, w - 1), Math.max(1, h - 1))
  ctx.setLineDash([])
  ctx.strokeStyle = "rgba(244,63,94,0.18)"
  ctx.lineWidth = 1
  ctx.beginPath()
  for (let x = x1 - h; x < x2 + h; x += 10) {
    ctx.moveTo(x, y + h)
    ctx.lineTo(x + h, y)
  }
  ctx.stroke()
}

// core-viewer.js 178-197 — verbatim except currentPlaybackTime()/D.duration/view
// come from the render context.
export function drawPlayhead(rc, ctx, pL, pW, pT, pH, opts = {}) {
  const D = rc.payload
  const t = rc.getPlaybackTime()
  if (t === null || !D.duration) return
  if (opts.visibleOnly && (t < rc.view.start || t > rc.view.start + rc.view.width)) return
  const x = opts.fullDuration ? pL + (t / D.duration) * pW : tToX(rc.view, t, pL, pW)
  ctx.save()
  ctx.strokeStyle = opts.stroke || "rgba(96,165,250,0.95)"
  ctx.fillStyle = opts.fill || "rgba(96,165,250,0.95)"
  ctx.lineWidth = opts.lineWidth || 1.5
  ctx.beginPath()
  ctx.moveTo(x, pT)
  ctx.lineTo(x, pT + pH)
  ctx.stroke()
  ctx.beginPath()
  ctx.arc(x, pT + 8, 3.5, 0, Math.PI * 2)
  ctx.fill()
  ctx.restore()
}
